import { apiClient } from './client';
import type { SecurityGroupInfo, SoftwarePool, SoftwarePoolDetail, SoftwarePoolWrite } from '@/types/oscar';

export function listSoftware(signal?: AbortSignal): Promise<SoftwarePool[]> {
  return apiClient.get<SoftwarePool[]>('/api/software', signal);
}
export function getSoftwarePool(id: number, signal?: AbortSignal): Promise<SoftwarePoolDetail> {
  return apiClient.get<SoftwarePoolDetail>(`/api/software/${id}`, signal);
}
export function createSoftwarePool(body: SoftwarePoolWrite): Promise<SoftwarePool> {
  return apiClient.post<SoftwarePool>('/api/software', body);
}
export function updateSoftwarePool(id: number, body: SoftwarePoolWrite): Promise<SoftwarePool> {
  return apiClient.patch<SoftwarePool>(`/api/software/${id}`, body);
}
/** Retire (soft-delete) a licence pool. Admin only. */
export function deleteSoftwarePool(id: number): Promise<{ SoftwarePoolId: number; Retired: boolean }> {
  return apiClient.delete<{ SoftwarePoolId: number; Retired: boolean }>(`/api/software/${id}`);
}
export interface SoftwareAssignBody { AssigneeKind: 'Person' | 'Asset'; PersonId?: number; AssetId?: number }
export function addSoftwareAssignment(id: number, body: SoftwareAssignBody): Promise<{ AssignmentId: number }> {
  return apiClient.post<{ AssignmentId: number }>(`/api/software/${id}/assignments`, body);
}
export function revokeSoftwareAssignment(id: number, assignmentId: number): Promise<unknown> {
  return apiClient.delete(`/api/software/${id}/assignments/${assignmentId}`);
}
/** The pool's Entra security-group panel: stored link, live Graph facts, suggested rule. */
export function getSoftwareSecurityGroup(id: number, signal?: AbortSignal): Promise<SecurityGroupInfo> {
  return apiClient.get<SecurityGroupInfo>(`/api/software/${id}/security-group`, signal);
}
/** Link this pool to another into a shared mirror group (allocations reconcile to the union). Admin only. */
export function linkSoftwarePool(id: number, otherPoolId: number): Promise<{ SoftwarePoolId: number; LinkGroupId: string; MemberIds: number[] }> {
  return apiClient.post(`/api/software/${id}/link`, { OtherPoolId: otherPoolId });
}
/** Remove this pool from its mirror group (existing allocations are kept). Admin only. */
export function unlinkSoftwarePool(id: number): Promise<{ SoftwarePoolId: number; Unlinked: boolean }> {
  return apiClient.delete(`/api/software/${id}/link`);
}
